import React from 'react';
import PropTypes from 'prop-types';
import {Formik, Form, Field, ErrorMessage} from 'formik';
import {schemaValidate, minLength, maxLength} from '../../../helpers/validation-helpers';
/* Components */
import Modal from '../../common/modal/modal';
import Input from '../../common/form-elements/input/input';
import Textarea from '../../common/form-elements/textarea/textarea';
import FormErrorMessage from '../../common/form-elements/form-error-message/form-error-message';

class CloneSettingsModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      itemName: this.props.itemName,
      dashboardDescription: this.props.dashboardDescription,
    };
  }

  handleSave = (values) => {
    this.props.onSave(values);
    this.props.onClose();
  };

  closeAndDiscard = () => {
    this.props.onClose();
  };

  render() {
    return (
      <Modal.Default isOpen={this.props.isOpen}>
        <Formik
          initialValues={{
            itemName: this.state.itemName,
            dashboardDescription: this.state.dashboardDescription,
          }}
          onSubmit={this.handleSave}
        >
          {(props) => {
            return (
              <Form>
                <div className="glu-modal__header glu-flex glu-flex-align-center">
                  <div className="glu-modal__title glu-flex-grow">
                    Name cloned {this.props.cloneTarget === 'dashboard' ? 'dashboard' : 'widget'}
                  </div>
                  <div className="glu-flex-shrink">
                    <button
                      aria-label="close"
                      type="button"
                      className="glu-btn-link g-icon g-icon-close"
                      onClick={this.closeAndDiscard}
                    />
                  </div>
                </div>
                <div className="glu-modal__body">
                  <div className="glu-content__section">
                    <div className="glu-form-row">
                      <label className="glu-label">
                        {this.props.cloneTarget === 'dashboard' ? 'Dashboard Name' : 'Widget Name'}
                      </label>
                      <Field
                        as={Input}
                        onChange={props.handleChange('itemName')}
                        autoFocus
                        name="itemName"
                        validate={schemaValidate([
                          minLength(),
                          maxLength(this.props.cloneTarget === 'dashboard' ? 50 : 30),
                        ])}
                        invalid={props.errors.itemName && props.touched.itemName}
                        placeholder="Enter New Name"
                        className="glu-form-input-pad"
                      />
                      <ErrorMessage name="itemName" component={FormErrorMessage} />
                    </div>
                    {this.props.cloneTarget === 'dashboard' && (
                      <div className="glu-form-row">
                        <label className="glu-label">Description</label>
                        <Field
                          as={Textarea}
                          onChange={props.handleChange('dashboardDescription')}
                          placeholder="Enter Dashboard Description"
                          name="dashboardDescription"
                          validate={schemaValidate(maxLength(250))}
                          value={this.props.dashboardDescription}
                          invalid={
                            props.errors.dashboardDescription && props.touched.dashboardDescription
                          }
                          maxChar={250}
                          className="glu-form-input-pad"
                        />
                        <ErrorMessage name="dashboardDescription" component={FormErrorMessage} />
                      </div>
                    )}
                  </div>
                </div>
                <footer className="glu-modal__footer">
                  <div className="glu-flex-grow glu-flex-row">
                    <div className="glu-flex-grow text-right">
                      <button
                        type="button"
                        onClick={this.closeAndDiscard}
                        className="glu-btn glu-btn--secondary"
                      >
                        Cancel
                      </button>
                    </div>
                    <div className="glu-flex-shrink">
                      <button className="glu-btn glu-btn--primary" type="submit">
                        Save
                      </button>
                    </div>
                  </div>
                </footer>
              </Form>
            );
          }}
        </Formik>
      </Modal.Default>
    );
  }
}

CloneSettingsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  dashboardDescription: PropTypes.string,
  itemName: PropTypes.string,
};

CloneSettingsModal.defaultProps = {
  dashboardDescription: '',
  itemName: '',
};

export default CloneSettingsModal;
